import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

interface Props {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export function CheckoutPayPalButton({
  onClick,
  loading = false,
  disabled = false,
}: Props) {
  const iconClasses = classNames(
    'checkout-paypal-button__paypal-icon',
    { 'checkout-paypal-button__paypal-icon--disabled': disabled },
  );

  return (
    <button className="checkout-paypal-button"
      type="button"
      onClick={onClick}
      disabled={loading || disabled}
      aria-label={I18n.t('discovery.checkout.paypal.payWithPayPal')}
    >
      {loading ?
        <span>{I18n.t('discovery.checkout.paypal.loading')}</span> :
        <span className={iconClasses}></span>
      }
    </button>
  );
}
